<template>
  <a
    :href="href"
    :target="target"
    :class="[$style.iconContainer, $style[iconType], $style.middle]"
  >
    <span :class="$style.icon"><font-awesome-icon :icon="icon" /></span>
    <div :class="$style.text">{{ name }}</div>
  </a>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'ExpandableIconComponent',
  props: {
    iconType: { type: String, default: 'iconBar' },
    href: { type: String, default: '/' },
    icon: { type: Object, default: faLink },
    target: { type: String, default: '_self' },
    name: { type: String, required: true }
  },
  components: { FontAwesomeIcon }
}
</script>

<style module>
  .iconContainer {
    background-color: var(--bg-drk);
    color: var(--text-lt);
    display: inline-block;
    -webkit-transition: all 0.5s ease-in-out 0s;
    transition: all 0.5s ease-in-out 0s;
    font-size: 1.2rem;
  }

  .icon {
    margin: 0.25em 0.5em;
  }

  .text {
    margin: 0 0.5em 0 0;
    display: none;
  }

  .iconContainer:hover {
    background-color: var(--accent-med);
  }

  .iconContainer:hover .text {
    display: inline-block;
  }

  a.iconContainer:hover ,
  a.iconContainer:hover:hover {
    color: var(--text-lt);
  }


  .bubbleIcons {
    border-radius: var(--border-radius);
    margin: 0.5rem;
  }

  .iconBar {
      padding: 0.5rem 0;
  }

  .iconBar:first-child {
      border-radius: var(--border-radius) 0 0 var(--border-radius);
  }

  .iconBar:last-child {
      border-radius: 0 var(--border-radius) var(--border-radius) 0;
  }

  .middle {
    vertical-align: middle;
  }
</style>
